// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../index';

import { gql } from 'graphql-tag';
import { CustomerRegistrationResponseFragmentDoc } from '../../../../auth/fragments/customerRegistrationResponse.generated';
export const DesignStudioWeddingRingSuccessNewCustomerFragmentDoc = gql`
    fragment designStudioWeddingRingSuccessNewCustomer on CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer {
  customer {
    ...customerRegistrationResponse
  }
}
    ${CustomerRegistrationResponseFragmentDoc}`;